import axios from "axios"; // 引入axios
import qs from "qs";
import apiList from "./apiFenYinTa"; // 引入API列表
import Vue from "vue";
import router from "../router/index";
import store from "../store/index";
const CryptoJS = require("crypto-js"); //引用加密源码js
const vueObject = new Vue({});

axios.defaults.headers["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// service 循环遍历输出不同的请求方法
let instance = axios.create({
  baseURL: store.state.config.baseURLFenYin,

  timeout: 60000
});

const Http = {}; //抱过请求方法的容器
// console.log(apiList)
let requestParams;
// 请求格式/参数的统一
for (let key in apiList) {
  let api = apiList[key]; // url
  // console.log(api)
  // console.log(key)

  Http[key] = async function(
    params, // 请求参数 get:url,put,post,patch(data),delete:url
    isFormData = false, //标识是否是 form-data请求
    config = {} //配置参数
  ) {
    if (api.config) {
      config = api.config;
    }

    config.headers = config.headers ? config.headers : {};

    var userInfo = vueObject.$store.getters.getUserInfo;
    if (userInfo != false) {
      config.headers.token = userInfo.token;
      // config.headers.timestamp = parseInt(Date.parse(new Date()) / 1000);
      config.headers.timestamp = "";
      config.headers.sign = "";
      config.headers.userId = userInfo.userId;
    }

    let newParams = {};
    // content-type 是否是form-data
    if (params && isFormData) {
      // form-data转换
      newParams = new FormData();
      for (var i in params) {
        if (typeof params[i] == "array") {
          var osnParams = {},
            osnParams = new FormData();
          for (let j in params[i]) {
            osnParams.append(j, params[i][j]);
          }
          newParams.append(i, osnParams);
        } else {
          newParams.append(i, params[i]);
        }
      }
    } else {
      newParams = qs.stringify(params);
    }
    // console.log(newParams)
    requestParams = newParams;

    config.isFormData = isFormData;
    config.signParam = params;

    // 不同请求的判断
    let response = {}; //请求的返回值
    if (
      api.method === "put" ||
      api.method === "post" ||
      api.method === "patch"
    ) {
      config.data = true;
      // put，post,patch请求
      // config.params = newParams

      try {
        response = await instance[api.method](api.url, newParams, config);
      } catch (err) {
        response = err;
      }
    } else if (api.method === "delete" || api.method === "get") {
      config.data = true;
      // delete,get请求
      config.params = newParams;

      try {
        response = await instance[api.method](api.url, config);
      } catch (err) {
        response = err;
      }
    }

    return response;
  };
}

// 请求拦截器的添加
instance.interceptors.request.use(
  (config) => {
    // console.log(config, 11);
    const tok =
      "5f5aac328cb6430e8c5fcf93dc97c5ae:f10f7fc5cf534aaf84a9557cc9c334d5";
    //  const hash = Base64.encode(tok);
    //  const hash = CryptoJS.enc.Base64(tok);

    const utf8 = CryptoJS.enc.Utf8.parse(tok);
    // console.log(utf8, 8888);
    const base64 = CryptoJS.enc.Base64.stringify(utf8);
    // console.log(base64, 646464);

    const Basic = "Basic " + base64;
    config.headers.Authorization = Basic;

    return config;
  },
  (error) => {
    console.log("请求错误");
    console.log(error);
    // 请求错误
    vueObject.$message("网络不稳定，请稍后重试！");
  }
);

// 响应拦截器
instance.interceptors.response.use(
  async (res) => {
    //请求成功
    if (typeof res.data == "string") {
      return res;
    }
    res.data.responseData = res;

    return res.data;
  },
  (error) => {
    console.log("响应错误");
    console.log(error);
    // 响应失败
    // vueObject.$message("网络不稳定，请重试！");
  }
);

export default Http;
